import { Injectable } from '@angular/core';
import * as Highstock from "highcharts/highstock";

require('highcharts/modules/exporting')(Highstock);
require('highcharts/modules/export-data')(Highstock);
require('highcharts/modules/offline-exporting')(Highstock);
require('highcharts/modules/annotations')(Highstock);

declare var require: any;

@Injectable()
export class HighchartsService {
  constructor() {
  }

  CreateChartLinear(el: Highstock.Options, data: any, title: string, isFutures: boolean = false, interval: string = '', isFirstLoad: boolean = true, YAxisText: string): Highcharts.Chart {
    const jsonData = JSON.parse(JSON.stringify(data));

    let values: Array<number> = new Array<number>();
    let dates: Array<string> = new Array<string>();
    let minValue: number;
    let maxValue: number;

    if (isFutures)
      minValue = parseFloat(jsonData[0].close.toFixed(2));
    else
      minValue = parseFloat(jsonData[0].value.toFixed(2));

    maxValue = minValue

    let chart: Highcharts.Chart;
    let modulo: number;

    switch (interval) {
      case '1w':
        modulo = 1;
        break;
      case '1m':
        modulo = 1;
        break;
      case '3m':
        modulo = 3;
        break;
      case '6m':
        modulo = 4;
        break;
      case 'max':
        modulo = Math.round(jsonData.length / 100);
        break;
    }

    //console.log("modulo : " + modulo);
    //console.log("jsonData.length : " + jsonData.length);

    let addDate: boolean;
    //let changeMonth: boolean = true;
    //let changeYear: boolean = true;
    //let index: number = 0;
    //let previousMonth: number;
    //let previousYear: number;

    //console.log("INITIAL dates.length : " + dates.length);

    jsonData.forEach((price: { close: number; value: number; date: string | number | Date; }) => {
      let currentValue: number;

      //if (interval == "max") {
      //  if (index > 0) {
      //    changeMonth = new Date(price.date).getMonth() != previousMonth;
      //    changeYear = new Date(price.date).getFullYear() > previousYear;

      //    //console.log("new Date(price.date).getMonth() : " + new Date(price.date).getMonth() + " previousMonth : " + previousMonth + " new Date(price.date).getFullYear() : " + new Date(price.date).getFullYear() + " previousYear : " + previousYear);
      //    //console.log("changeMonth : " + changeMonth + " changeYear : " + changeYear);
      //  }

      //  previousMonth = new Date(price.date).getMonth();
      //  previousYear = new Date(price.date).getFullYear();        
      //}

      if (isFutures)
        currentValue = parseFloat(price.close.toFixed(2));
      else
        currentValue = parseFloat(price.value.toFixed(2));

      //if (interval == "max") { // "max"
      //  addDate = (changeMonth == true) || (changeYear == true);

      //  //console.log("addDate : " + addDate);
      //}
      //else // Tout sauf "max"
      //  addDate = (index % modulo == 0);

      addDate = true;

      if (addDate) {
        const dateToPush: string = new Date(price.date).toLocaleDateString('fr-FR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });

        //if (interval == "max" && dates.length > 2) {
        //  debugger;
        //}

        //console.log("dates.push(" + dateToPush + ")");

        dates.push(dateToPush);

        //console.log("CURRENT dates.length : " + dates.length);
      }
      //else {
      //if (interval != "max")
      //dates.push('');
      //}

      values.push(currentValue);

      if (currentValue < minValue)
        minValue = currentValue

      if (currentValue > maxValue)
        maxValue = currentValue

      //index++;
    });

    //console.log("FINAL dates.length : " + dates.length);

    let vOffset: number = 50;
    const vSpread: number = maxValue - minValue;

    vOffset = vSpread / 2;

    //$(".highcharts-root").clientHeight
    const modalHeight = document.querySelector('.mdc-dialog__container').clientHeight;
    const modalWidth = document.querySelector('.mdc-dialog__container').clientWidth;

    let imagePosX: number = Math.round(modalWidth / 2.4);
    let imagePosY: number = Math.round(modalHeight / 2);

    if (!isFirstLoad) {
      imagePosY = 90;
    }

    //console.log(imagePosX + " " + imagePosY);

    let options: any = {
      chart: {
        type: 'line',
        zoomType: 'x',
        backgroundColor: null,
        resetZoomButton: {
          theme: {
            style: {
              color: '#EF7D19',
              marginRight: "100px",
              margin: "20px",
              padding: "200px"
            },
            fill: '#FFF',
            stroke: '#EF7D19',
            r: 16
          }
        },
        events: {
          render() {
          },
          // load: function () {
          //   this.renderer.image('https://my.captainfarmer.com/assets/images/aide.svg', imagePosX, imagePosY, 190, 190)
          //     .add()
          //     .css({
          //       opacity: 0.5
          //     });
          // },

        },
      },
      responsive: {
        rules: [{
          condition: {
            minWidth: 0,
            maxWidth: 800
          },
          chartOptions: {
            chart: {
              height: 255
            },
            subtitle: {
              text: null
            },
            navigator: {
              enabled: false 
            }
          }
        }]
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        min: 0,
        title: {
          text: YAxisText
        }
      },
      legend: {
        layout: 'proximate',
        align: 'left'
      },
      plotOptions: {

        series: {
          stacking: 'normal', 
          color: '#EF7D19',
        }
      },
      series: [{
        name: title,
        data: values,
        showInLegend: false,
        dataLabels: {
          enabled: false
        }
      }],
      exporting: {
        fallbackToExportServer: false,
        enabled: true,
        width: 1000,
        height: 400,
        sourceWidth: 1000,
        sourceHeight: 400,
        scale: 1,
        chartOptions: {
          title: {
            text: title,
          },
          chart: {
            plotBackgroundImage: 'data:image/png;base64,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',
            backgroundColor: "#fff",

          }
        },
        buttons: {
          contextButton: {
            enabled: false,
            width: 25,
            height: 25,
            symbol: 'url(./assets/images/export.png)',
            symbolX: 38,
            symbolY: 0,
            menuItems: ['viewFullscreen', 'separator', 'downloadPNG', 'downloadSVG', 'downloadPDF', 'separator']
          },
        }
      }
    }
    options.credits = false;
    options.xAxis.categories = dates;
    options.xAxis.startOnTick = true;
    options.xAxis.endOnTick = false;
    options.yAxis.min = minValue - vOffset;
    options.yAxis.max = maxValue + vOffset;
    options.yAxis.startOnTick = false;
    options.yAxis.endOnTick = false;

    chart = Highstock.chart(el, options);

    return chart;
  }
}

